$(function() {
//pagetopボタン
//--------------------------------------------------------------------
if ($("body").width() < 959){
    var topBtn = $('.js-pagetop');
    topBtn.hide();
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
    //スクロールしてトップ
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });

    $(window).bind("scroll", function() {
        // ドキュメントの高さ
        scrollHeight = $(document).height();
        // ウィンドウの高さ+スクロールした高さ→ 現在のトップからの位置
        scrollPosition = $(window).height() + $(window).scrollTop();
        // フッターの高さ
        footHeight = $("#footer").height();

        // スクロール位置がフッターまで来たら
        if ( scrollHeight - scrollPosition  <= footHeight ) {
            // ページトップリンクをフッターに固定
            $(".js-pagetop").css({"position":"absolute","top": "-40px"});
        } else {
            // ページトップリンクを右下に固定
            $(".js-pagetop").css({"position":"fixed","bottom": "0px","top": "auto"});
        }
    });
}else{
    var topBtn = $('.js-pagetop');
    topBtn.hide();
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
    //スクロールしてトップ
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });

    $(window).bind("scroll", function() {
        // ドキュメントの高さ
        scrollHeight = $(document).height();
        // ウィンドウの高さ+スクロールした高さ→ 現在のトップからの位置
        scrollPosition = $(window).height() + $(window).scrollTop();
        // フッターの高さ
        footHeight = $("#footer").height();

        // スクロール位置がフッターまで来たら
        if ( scrollHeight - scrollPosition  <= footHeight ) {
            // ページトップリンクをフッターに固定
            $(".js-pagetop").css({"position":"absolute","right": "0px","top": "-40px"});
        } else {
            // ページトップリンクを右下に固定
            $(".js-pagetop").css({"position":"fixed","right": "0px","bottom": "0px","top": "auto"});
        }
    });
};
});

// ======================================
//スクロールでフェードアップ
// ======================================

$(function () {
  const elements = document.querySelectorAll('.scroll-fadeup');

  const options = {
    threshold: 0.2
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.dataset.delay || 0;
        setTimeout(() => {
          entry.target.classList.add('is-visible');
        }, delay);
        observer.unobserve(entry.target);
      }
    });
  }, options);

  elements.forEach(el => observer.observe(el));
});


/*fancybox
----------------------------*/
$('.js_modalOpen').fancybox({
  loop: true,
  infobar : false, 
  arrows: true,        
  infobar: false,
});
